import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCollaborationPointerRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="collaboration-pointer-right, cursor, agents"><path d="M12 12L4.75 9.41071L19.25 4.75L14.5893 19.25L12 12Z" stroke="currentColor" strokeWidth="1.5"/><path d="M2.25 13.25L8.625 15.375L10.75 21.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCollaborationPointerRight;
